export const RETAILER_OPTIONS = [
  { id: "all", label: "All" },
  { id: "morrison", label: "Morrisons" },
  { id: "asda", label: "Asda" },
  { id: "tesco", label: "Tesco" },
  { id: "sainsbury", label: "Sainsbury's" },
];

export const PRICE_MODE_OPTIONS = [
  { id: "base", label: "Base Price" },
  { id: "offer_loyalty", label: "Offer + Loyalty" },
];

export const BASE_PRICE_LABEL = PRICE_MODE_OPTIONS[0].label;
export const OFFER_LOYALTY_LABEL = PRICE_MODE_OPTIONS[1].label;

export function priceModeChipClass(active) {
  return [
    "shrink-0 whitespace-nowrap rounded-full px-3 py-1.5 text-[13px] font-bold shadow-sm sm:px-4 sm:text-[15px]",
    active
      ? "border-2 border-[#7352C7] bg-[#7352C71A] text-[#7352C7]"
      : "border-2 border-[#E6EAF0] bg-white text-[#6E7B86]",
  ].join(" ");
}

export const RETAIL_KEYS = new Set(["tesco", "asda", "morrison", "sainsbury"]);

export const PLATFORM_LABELS = {
  tesco: "Tesco",
  asda: "Asda",
  morrison: "Morrisons",
  sainsbury: "Sainsbury's",
};

export function normalizeStoreKey(platform) {
  const p = String(platform || "").trim().toLowerCase();
  if (!p) return "";
  if (p.includes("tesco")) return "tesco";
  if (p.includes("asda")) return "asda";
  if (p.includes("morris")) return "morrison";
  if (p.includes("sains")) return "sainsbury";
  return "";
}

export function getCatalogFilterModes(retailer, priceMode) {
  const isOfferMode = priceMode === "offer_loyalty";
  const isFeaturesCompareMode = retailer === "all" && !isOfferMode;
  const isFeaturesOfferCompareMode = retailer === "all" && isOfferMode;
  const isPlatformBaseMode = retailer !== "all" && !isOfferMode;
  const isPlatformOfferMode = retailer !== "all" && isOfferMode;

  return {
    isOfferMode,
    isFeaturesCompareMode,
    isFeaturesOfferCompareMode,
    isPlatformBaseMode,
    isPlatformOfferMode,
  };
}
